<template>
  <div class="spinner-dots">
    <span
      v-for="n in 3"
      :key="n"
      class="spinner-dots__dot"
      :style="{ width: `${size}px`, height: `${size}px` }"
    />
  </div>
</template>

<script lang="ts" setup>
withDefaults(defineProps<{ size?: number }>(), { size: 8 })
</script>
